import { MapObject } from '../../../shared/utilities/types.utilities';

import * as faker from 'faker';
import { USER_DOMAIN } from '../users/user.utilities';

let SPACE_COUNT: number = 0;

export function generateMockSpace(id?: string, zones?: string[]): MapObject {
    if (!id) {
        id = `space-${SPACE_COUNT++}`;
    }
    const name = `${faker.name.firstName()} ${faker.name.lastName()} Space`;
    const linked = Math.floor(Math.random() * 99999) % 2 === 0 && SPACE_COUNT > 1;
    return {
        id,
        name: `${name} with an long name`,
        short_name: name,
        map_id: `${SPACE_COUNT}`,
        capacity: Math.floor(Math.random() * 20 + 1) * 2,
        email: `${name.toLowerCase().split(' ').join('.')}@${USER_DOMAIN}`,
        type: faker.commerce.productName(),
        searchable: Math.floor(Math.random() * 99999) % 2 === 0,
        controlable: Math.floor(Math.random() * 99999) % 2 === 0,
        bookable: Math.floor(Math.random() * 99999) % 2 === 0,
        cost_hour: Math.floor(Math.random() * 300) * 100,
        setup: Math.floor(Math.random() * 6) * 5,
        breakdown: Math.floor(Math.random() * 6) * 5,
        zones: zones || ['zone_lvl-0'],
        consent: Math.floor(Math.random() * 99999) % 3 !== 0,
        linked_rooms: linked ? [`space-${Math.floor(Math.random() * (SPACE_COUNT - 1))}`] : [],
        chatbot_messages: [
            {
                enabled: false,
                key: 'recorded-notice',
                group: 'all',
                type: 'notice',
                style: 'alert',
                text: 'For your privacy, this call may not be recorded.',
                delay: 0,
            },
            {
                enabled: false,
                key: 'intro-message',
                group: 'patient',
                type: 'chatbot',
                style: 'html',
                text: `Hi {{ patient_name }}!<br><br>We will be with you soon.<br><br>Whilst you wait, you may like to write some questions for your healthcare provider in the chat box below.`,
                delay: 5 * 1000,
            },
            {
                enabled: false,
                key: 'patience-message',
                group: 'patient',
                type: 'chatbot',
                style: 'text',
                text:
                    'Your Healthcare Provider will be with you soon. Thank you for your patience.',
                delay: 30 * 1000,
            },
            {
                enabled: false,
                key: 'wait-time-notice',
                group: 'patient',
                type: 'notice',
                style: 'alert',
                text:
                    'You have been waiting more than 10 minutes. If you have not had contact with someone, please contact your service provider.',
                delay: 10 * 60 * 1000,
            },
            {
                enabled: false,
                key: 'file-notice',
                group: 'all',
                type: 'notice',
                style: 'alert',
                text:
                    'You may download any files shared by you or your healthcare provider at the end of the call. We do not store these on our system.',
                delay: 0,
            },
            {
                enabled: false,
                key: 'feeling-question',
                group: 'patient',
                type: 'chatbot',
                style: 'emoji',
                text: 'How are you feeling today?',
                answers: ['Bad', 'Neutral', 'Good'],
                delay: 5 * 1000,
            },
            {
                enabled: false,
                key: 'experience-question',
                group: 'patient',
                type: 'chatbot',
                style: 'boolean',
                text: 'Are you enjoying your experience with MyVirtualCare?',
                answers: ['No', 'Yes'],
                delay: 5 * 1000,
            },
            {
                enabled: false,
                key: 'pain-level-question',
                group: 'patient',
                type: 'chatbot',
                style: 'rating',
                text: 'How would you rate your pain level?',
                answers: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                delay: 5 * 1000,
            },
        ],
    };
}
